import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { IStatus, IStatusForm, IStatusUpdatePayload } from '../statusuri-proiecte.interface';
import { StatusuriProiecteService } from '../statusuri-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-edit-statusuri-proiecte',
    templateUrl: './edit-statusuri-proiecte.component.html',
    styleUrls: ['./edit-statusuri-proiecte.component.scss']
})
export class EditStatusuriProiecteComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Arhivat', value: '1' },
        { key: 'Nearhivat', value: '0' },
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        color: new FormControl(this.data.color, [Validators.required]),
        arhiva: new FormControl(this.data.arhiva.toString(), [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IStatus,
        private dialogRef: MatDialogRef<EditStatusuriProiecteComponent>,
        private statusuriProiecteService: StatusuriProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const {
            name,
            color,
            arhiva,
        } = this.form.value as IStatusForm;
        const payload: IStatusUpdatePayload = {
            id_status: this.data.id,
            name,
            color,
            arhiva,
        };

        this.statusuriProiecteService
            .updateStatus(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
